
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/mypage/edit",
      function () {
        return require("private-next-pages/user/mypage/edit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/mypage/edit"])
      });
    }
  